<template>
    <div class="installation-prompt" v-if="visible">
        <svg class="close-btn" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" @click="dismiss">
            <circle cx="15" cy="15" r="15" fill="#F1F2F4"/>
            <path d="M17.5277 11.8281L15.1929 14.1629L12.8476 11.8177C12.6103 11.5803 12.238 11.5798 12.0001 11.8177C11.7628 12.055 11.7622 12.4273 12.0001 12.6652L14.335 15L12.0001 17.3348C11.7628 17.5722 11.7622 17.9444 12.0001 18.1823C12.2375 18.4197 12.6097 18.4202 12.8476 18.1823L15.1825 15.8475L17.5173 18.1823C17.7547 18.4197 18.1269 18.4202 18.3648 18.1823C18.6022 17.945 18.6027 17.5727 18.3648 17.3348L16.03 15L18.3648 12.6652C18.6022 12.4278 18.6027 12.0556 18.3648 11.8177C18.1264 11.5803 17.7651 11.5907 17.5277 11.8281L17.5277 11.8281Z" fill="#424242"/>
        </svg>
        <p class="display-large bold margin">Install APP</p>
        <div class="grid-x grid-margin-x justify-between align-middle">
            <div class="cell shrink">
                <img src="/media/static/icons/android/android-launchericon-72-72.png" alt="PWA Icon" class="flex">
            </div>
            <div class="cell auto">
                <p class="display-small color-battleship-gray margin-0">
                    Add the app to your home screen to order food quicker and receive order notifications.
                </p>
            </div>
        </div>
        <div class="align-middle grid-x grid-padding-x align-right bottom-section" v-if="!isIOS">
            <div class="cell shrink">
                <a class="dismiss color-primary margin-0" @click.prevent="dismiss">Not now</a>
            </div>
            <div class="cell shrink">
                <button class="button primary margin-0" @click.prevent="install">Install</button>
            </div>
        </div>
        <div class="align-center grid-x grid-padding-x ios-bottom-section" v-else>
            <p class="display-small margin-0">Just tap
                <svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.48975 15.3857C9.93066 15.3857 10.3101 15.0166 10.3101 14.5859V4.05518L10.2485 2.51709L10.9355 3.24512L12.4941 4.90625C12.6377 5.07031 12.8428 5.15234 13.0479 5.15234C13.4683 5.15234 13.7964 4.84473 13.7964 4.42432C13.7964 4.20898 13.7041 4.04492 13.5503 3.89111L10.0845 0.54834C9.87939 0.343262 9.70508 0.271484 9.48975 0.271484C9.28467 0.271484 9.11035 0.343262 8.89502 0.54834L5.4292 3.89111C5.27539 4.04492 5.19336 4.20898 5.19336 4.42432C5.19336 4.84473 5.50098 5.15234 5.93164 5.15234C6.12646 5.15234 6.35205 5.07031 6.49561 4.90625L8.04395 3.24512L8.74121 2.51709L8.67969 4.05518V14.5859C8.67969 15.0166 9.04883 15.3857 9.48975 15.3857ZM3.61426 23.4146H15.3755C17.5186 23.4146 18.5952 22.3481 18.5952 20.2358V10.0024C18.5952 7.89014 17.5186 6.82373 15.3755 6.82373H12.5146V8.47461H15.3447C16.3599 8.47461 16.9443 9.02832 16.9443 10.0947V20.1436C16.9443 21.21 16.3599 21.7637 15.3447 21.7637H3.63477C2.60938 21.7637 2.04541 21.21 2.04541 20.1436V10.0947C2.04541 9.02832 2.60938 8.47461 3.63477 8.47461H6.4751V6.82373H3.61426C1.47119 6.82373 0.394531 7.89014 0.394531 10.0024V20.2358C0.394531 22.3481 1.47119 23.4146 3.61426 23.4146Z" fill="#007AFF"/>
                </svg>
                then 'Add to Home Screen'
            </p>
        </div>
    </div>
</template>
<script lang="ts">
import UserModule from '@/stores/modules/user';
import Cookie from '@/utils/cookies';
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { isIOS } from '@/utils/utilities';

@Component
export default class InstallationPrompt extends Vue
{
    installEvent: Event | null = null;
    dismissed: boolean = false;
    userModule!: UserModule;

    created() {
        this.userModule = getModule(UserModule, this.$store);
    }

    mounted() {
        const dimissedBefore = Cookie.get('dismiss_install');
        if (dimissedBefore) {
            this.dismissed = true;
        }
        this.installEvent = (<any>window).beforeinstallpromptEvent ?? null;
    }

    async install() {
        if (this.installEvent && this.isLoggedIn) {
            (<any>this.installEvent).prompt();
            const { outcome } = await (<any>this.installEvent).userChoice;
            if ((<any>window).gtag !== undefined && (<any>window).gaMeasurementId !== undefined) {
                (<any>window).gtag(
                    'event', (outcome === 'accepted') ? 'installed_app' : 'dismissed_install', {
                    'event_category': 'pwa',
                    'event_label': 'App installation'
                });
            }
            this.installEvent = null;
        }
    }

    dismiss() {
        this.dismissed = true;
        const now = new Date();
        Cookie.set('dismiss_install', true, new Date(now.getTime() + 24 * 60 * 60 * 1000));
        if ((<any>window).gtag !== undefined && (<any>window).gaMeasurementId !== undefined) {
            (<any>window).gtag(
                'event', 'dismissed_install', {
                'event_category': 'pwa',
                'event_label': 'App installation'
            });
        }
    }

    get visible() {
        return (this.installEvent !== null && !this.dismissed && this.isLoggedIn) || (this.isLoggedIn && this.isIOS && !this.dismissed && !(window.navigator as any).standalone);
    }


    get isLoggedIn() {
        return this.userModule.currentUser !== null;
    }

    get isIOS() {
        return isIOS();
    }
}

</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.installation-prompt {
    position: relative;
    bottom: 0px;
    background-color: var(--white);
    border-radius: var(--global-radius);
    padding: 20px 15px;
    width: 100%;
    box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.2);

    .close-btn {
        position: absolute;
        top: 18px;
        right: 15px;
    }

    @include breakpoint(large) {
        right: 30px;
        width: 350px;
    }

    .dismiss {
        display: block;
        font-weight: 600;
    }

    .bottom-section {
        margin-top: 10px;
    }

    .ios-bottom-section {
        background-color: #F1F2F4;
        padding: 15px 35px;
        margin: 15px -15px -20px -15px;

        svg {
            margin-left: 5px;
            position: relative;
            top: 5px;
            margin-right: 5px;
        }
    }

}

</style>
